// Sub-consultant convention (firm model, 2026-06):
//   · stored as scope rows flagged `isSubConsultant`, values kept NEGATIVE
//     (unchanged from the existing data — no migration)
//   · entered and displayed as POSITIVE costs in the sub-consultants section
//   · deducted from the gross forecast total to give the NET fee the firm keeps
export const isSubRow = (s) => !!s?.isSubConsultant;

export const monthlySum = (s, months) =>
  (months || []).reduce((a, mo) => a + (Number(s?.revenue?.[mo]) || 0), 0);

const allMonthsSum = (s) =>
  Object.values(s?.revenue || {}).reduce((a, b) => a + (Number(b) || 0), 0);

// A sub row's magnitude: contract value when set, otherwise its scheduled fees.
export const subMagnitude = (s) => {
  const cv = Math.abs(Number(s?.contractValue) || 0);
  return cv > 0 ? cv : Math.abs(allMonthsSum(s));
};

// Gross / sub deduction / net for a single project's scope array.
// Sub deduction prefers monthly fees inside the window; when a sub row carries
// only a fee (no monthly spread) its fee is used so the deduction is visible.
export const grossNetSub = (scopes, months) => {
  let gross = 0;
  let subs = 0;
  for (const s of scopes || []) {
    if (isSubRow(s)) subs += Math.abs(monthlySum(s, months)) || subMagnitude(s);
    else gross += monthlySum(s, months);
  }
  return { gross, subs, net: gross - subs };
};

// Display value for a sub-consultant cell (positive) and the value to store.
export const toDisplay = (v) => Math.abs(Number(v) || 0);
export const toStored = (v) => -Math.abs(Number(v) || 0);
